import { useCallback } from 'react';

import { useJWT } from '@/hooks/useJWT.hook';
import { useUsername } from '@/hooks/useUsername';

type UseAuth = {
  jwt: string;
  username: string;
  onLogout: () => void;
};

export const useAuth = (): UseAuth => {
  const { jwt, removeJWT } = useJWT();
  const { username, removeItem: removeUsername } = useUsername();

  const handleLogout = useCallback(() => {
    removeJWT();
    removeUsername();
  }, [removeJWT, removeUsername]);

  return {
    jwt,
    username,
    onLogout: handleLogout,
  };
};
